<template>
  <router-link :to="url || '/pontoDeInteresse/' + interestPoint.id" class="interest-point-item">
    <div class="zoomable-image image"><img :src="interestPoint.images[0] && interestPoint.images[0].image_url"></div>
    <h2 class="title" v-if="interestPoint.translation">{{interestPoint.translation.title}}</h2>
    <p class="subtype" v-if="interestPoint.subtype">{{interestPoint.subtype}}</p>
    <p class="description" v-if="description && interestPoint.translation && interestPoint.translation.description">{{interestPoint.translation.description}}</p>
  </router-link>
</template>
<script>

export default {
  name: 'interestPointItem',
  props: ['url', 'interestPoint', 'description'],
  components: {
  },
  data() {
    return {
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>
.image {
  width: 100%;
}
</style>